import { Component, ChangeDetectionStrategy } from '@angular/core';
import { routerTransition } from './shared/router-transition/router-transition.component';
import * as AOS from 'aos';
import { Router, NavigationEnd } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from './shared/snack-bar/snack-bar.component';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from "ngx-spinner";
import { MatDialog } from '@angular/material';
import {Overlay} from '@angular/cdk/overlay';
import {MatMenuModule} from '@angular/material/menu';
import {DialogComponent} from './shared/dialog/dialog.component'

declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    routerTransition
  ]
})
export class AppComponent {
  title = 'edc-project';

  scrollTop = 0;
  hideNav = false;
  showForm = false;
  bgColorButton = '#63BCF8'
  i = 0
  dialogReponse = true

  constructor(private router: Router, 
    public dialog: MatDialog,
    private overlay: Overlay,
    private snackBar: MatSnackBar, 
    private cookieService: CookieService, 
    private spinner: NgxSpinnerService) {
    router.events.subscribe((y: NavigationEnd) => {
      if (y instanceof NavigationEnd) {
        gtag('config', 'UA-135464323-1', { 'page_path': y.url });
      }
    });
  }
  ngOnInit() {
    this.openDialog()
    //this.changeColor()
    // window.addEventListener('scroll', this.onScroll, true);
    AOS.init();
    if (!this.cookieService.check('visited')) {
      this.setCookie();
      this.cookieSnackBar();
    }

    /** spinner starts on init */
    this.spinner.show();

    setTimeout(() => {
      /** spinner ends after 1 seconds */
      this.spinner.hide();
    }, 1000);
  }

  changeColor() {
    var arrayColor = ["#1D2C4D", "#6EA0BF", "#75DDDD", "#4CBCC4", "#268A93"]
    var button = document.getElementById('btn_color')
    var pannel = document.querySelector('.mat-menu-content')
    
    setInterval(() => {
      if(this.i === 5) {
        this.i = 0  
      }
      button.style.backgroundColor = arrayColor[this.i]
      this.i++
    }, 500)
  }

  // onScroll(event) {
  //   if (window.pageYOffset > 550) {
  //     const element = document.getElementById('nav');
  //     element.classList.add('hidden');
  //   } else {
  //     const element = document.getElementById('nav');
  //     element.classList.remove('hidden');
  //   }
  // }

  getState(outlet) {
    return outlet.activatedRouteData.state;
  }

  setCookie() {
    this.cookieService.set('visited', 'true', 0.5);
  }

  cookieSnackBar() {
    this.snackBar.openFromComponent(SnackBarComponent, {
      horizontalPosition: 'left',
      verticalPosition: 'bottom',
      panelClass: 'cookieSnackBar'
    });
  }

  openDialog(): void {
    let hasVisitedEpro = false
    setInterval(() => {
      this.dialog.closeAll()
      if(this.router.url != '/epro' && this.router.url != '/contact/contact-form' &&hasVisitedEpro === false && this.dialog && this.dialogReponse === true) {
        let dialogRef = this.dialog.open(DialogComponent, {
          panelClass: 'dialog_panel',
          position: {bottom: "0", right: "0"},
          hasBackdrop: false,
          scrollStrategy: this.overlay.scrollStrategies.noop(),
          autoFocus: false,
        });
  
        dialogRef.afterClosed().subscribe(result => {
          this.dialogReponse = result
        });
      } else {
        hasVisitedEpro = true
      }
    }, 60000)
  }
}
